import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ChatbotPage from "./pages/ChatbotPage";
import ChatbotPageStructured from "./pages/ChatbotPageStructured";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import SessionListPage from "./pages/SessionListPage";
import SessionDetailPage from "./pages/SessionDetailPage";
import ErrorMonitoring from "./pages/ErrorMonitoring";

function AppRouter() {
  return (
    <Routes>
      {/* Default route - loads chatbot page */}
      <Route path="/" element={<ChatbotPage />} />

      {/* Main chatbot route */}
      <Route path="/chat" element={<ChatbotPage />} />

      {/* QR/table short-code route (e.g. /1X3CV7) */}
      <Route path="/:tableCode" element={<ChatbotPage />} />

      {/* Structured chatbot route - with enhanced UI components */}
      <Route path="/chat/structured" element={<ChatbotPageStructured />} />

      {/* Public session tracking routes */}
      <Route path="/sessions" element={<SessionListPage />} />
      <Route path="/sessions/:sessionId" element={<SessionDetailPage />} />

      {/* Error monitoring dashboard - super-admin only */}
      <Route
        path="/errors"
        element={
          <ProtectedRoute requireSuperAdmin={true}>
            <ErrorMonitoring />
          </ProtectedRoute>
        }
      />

      {/* Admin login route */}
      <Route path="/admin/login" element={<AdminLogin />} />

      {/* Admin dashboard routes - protected */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/:section/*"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />

      {/* Catch all - redirect to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default AppRouter;
